/* mo-home-bf-y-hero: homepage Black Friday hero behaviour (lane homebf, 2026-11-04). No library.
   The server HTML holds every brand's spotlight, index cell and photo; this script only chooses which one shows.
   - rotation through the live brands every data-autoplay ms; hover or keyboard focus on a brand shows it and holds;
     on phones a tap on another brand shows it first (a second tap opens the brand page). Pause button for everyone.
   - the brand photo is loaded one turn ahead and decoded before it is shown.
   - countdown to 11:59:59 pm America/New_York on the open brand's end day (data-end, YYYYMMDD), every second;
     once a minute and without seconds under reduced motion. The server HTML already says "Ends <date>".
   - reduced motion: no rotation, no sweep, no push-in (CSS). Save-Data: no rotation and no ambient loop.
   - Offer details opens the terms dialog. */
(function () {
  'use strict';
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var RM = mq('(prefers-reduced-motion: reduce)');
  var SD = !!(navigator.connection && navigator.connection.saveData);
  var MOB = 820;

  function nyOffsetMin(ts) {
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var p = {};
      f.formatToParts(new Date(ts)).forEach(function (x) { p[x.type] = x.value; });
      var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
      return Math.round((asUTC - ts) / 60000);
    } catch (e) { return -300; }
  }
  function deadline(ymd) {
    if (!/^\d{8}$/.test(ymd || '')) return 0;
    var y = +ymd.slice(0, 4), m = +ymd.slice(4, 6), d = +ymd.slice(6, 8);
    var guess = Date.UTC(y, m - 1, d, 23, 59, 59);
    return guess - nyOffsetMin(guess) * 60000;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function mobile() { return window.innerWidth <= MOB; }

  function init(r) {
    if (r.__hbf) return; r.__hbf = 1;
    if (SD) r.classList.add('mo-hbf--still');
    var dlg = r.querySelector('.mo-hbf__dlg');
    Array.prototype.forEach.call(r.querySelectorAll('.mo-hbf__terms-btn'), function (b) {
      b.addEventListener('click', function () { if (!dlg) return; if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
    });
    if (dlg) {
      var x = dlg.querySelector('.mo-hbf__dlg-x');
      if (x) x.addEventListener('click', function () { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); });
      dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
    }

    var sl = Array.prototype.slice.call(r.querySelectorAll('.mo-hbf__ph'));
    var cells = Array.prototype.slice.call(r.querySelectorAll('.mo-hbf__cell'));
    var spots = Array.prototype.slice.call(r.querySelectorAll('.mo-hbf__spot'));
    var DUR = Math.max(3000, parseInt(r.getAttribute('data-autoplay'), 10) || 6500);
    r.style.setProperty('--hbf-dur', (DUR / 1000) + 's');
    var useClock = r.getAttribute('data-clock') === '1';
    var i = 0, t = 0, held = false, userPaused = false, offscreen = false, running = false, clockTimer = 0;

    function tick() {
      var sp = spots[i];
      Array.prototype.forEach.call(r.querySelectorAll('[data-hbf-count]'), function (el) { if (!sp || !sp.contains(el)) el.hidden = true; });
      if (!useClock || !sp) return;
      var el = sp.querySelector('[data-hbf-count]');
      var end = deadline(sp.getAttribute('data-end'));
      if (!el || !end) return;
      el.setAttribute('aria-hidden', 'true');
      var left = end - Date.now();
      if (left <= 0) { el.hidden = true; return; }
      var s = Math.floor(left / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      var txt = RM ? (d ? d + (d === 1 ? ' day ' : ' days ') : '') + h + ' hr ' + m + ' min left'
                   : (d ? d + (d === 1 ? ' day ' : ' days ') : '') + pad(h) + ':' + pad(m) + ':' + pad(sec) + ' left';
      if (el.textContent !== txt) el.textContent = txt;
      el.hidden = false;
    }
    function hydrate(fig) {
      if (!fig) return;
      var im = fig.querySelector('img');
      if (im && im.loading === 'lazy') { im.loading = 'eager'; if (im.decode) im.decode().catch(function () {}); }
    }
    function go(n, user) {
      if (!sl.length) return;
      var prev = i;
      i = (n + sl.length) % sl.length;
      sl.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      cells.forEach(function (c, k) { c.classList.toggle('is-on', k === i); });
      spots.forEach(function (s, k) {
        if (k === i) { s.hidden = false; if (prev !== i && !RM) { s.classList.remove('is-in'); void s.offsetWidth; s.classList.add('is-in'); } }
        else { s.hidden = true; s.classList.remove('is-in'); }
      });
      r.setAttribute('data-tone', sl[i].getAttribute('data-tone') || 'dark');
      hydrate(sl[i]);
      if (running) hydrate(sl[(i + 1) % sl.length]);
      if (mobile() && user) {
        var ol = cells[i] && cells[i].closest('ol'), li = cells[i] && cells[i].parentNode;
        if (ol && li) ol.scrollTo({ left: li.offsetLeft - 16, behavior: RM ? 'auto' : 'smooth' });
      }
      tick();
      schedule();
    }
    function paused() { return userPaused || held || offscreen || document.hidden; }
    function schedule() {
      clearTimeout(t);
      if (!running || paused()) return;
      t = setTimeout(function () { go(i + 1, false); }, DUR);
    }

    cells.forEach(function (c, k) {
      c.addEventListener('mouseenter', function () { if (mobile()) return; held = true; if (k !== i) go(k, true); else schedule(); });
      c.addEventListener('focus', function () {
        var kb = true; try { kb = c.matches(':focus-visible'); } catch (e) {}
        if (!kb) return; held = true; if (k !== i) go(k, true); else schedule();
      });
      c.addEventListener('click', function (e) {
        if (mobile() && k !== i) { e.preventDefault(); userPaused = true; syncPause(); go(k, true); }
      });
    });
    var idx = r.querySelector('.mo-hbf__index');
    if (idx) {
      idx.addEventListener('mouseleave', function () { if (mobile()) return; held = false; schedule(); });
      idx.addEventListener('focusout', function (e) { if (!idx.contains(e.relatedTarget)) { held = false; schedule(); } });
    }
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { offscreen = !es[0].isIntersecting; schedule(); }, { threshold: 0.15 }).observe(r);
    }

    var pb = r.querySelector('.mo-hbf__pause');
    var canRun = sl.length > 1 && sl.length === cells.length && cells.length === spots.length && !RM && !SD;
    function syncPause() {
      if (!pb) return;
      pb.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      pb.setAttribute('aria-label', pb.getAttribute(userPaused ? 'data-play' : 'data-pause') || '');
    }
    if (pb && canRun) {
      pb.hidden = false;
      pb.addEventListener('click', function () { userPaused = !userPaused; syncPause(); schedule(); });
    }

    tick();
    if (useClock) clockTimer = setInterval(tick, RM ? 60000 : 1000);

    function begin() {
      if (!canRun || running) return;
      var ric = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
      var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
      /* start the push-in and the rotation only after two painted frames (a background tab paints none) */
      ric(function () { raf(function () { raf(function () {
        if (running) return;
        running = true;
        hydrate(sl[(i + 1) % sl.length]);
        r.classList.add('is-run');
        schedule();
      }); }); });
    }
    if (document.readyState === 'complete') setTimeout(begin, 1200);
    else window.addEventListener('load', function () { setTimeout(begin, 900); });
    setTimeout(function () { sl.forEach(function (s) { var im = s.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; }); }, 4000);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mo-hbf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
